export default __webpack_public_path__ + "static/media/ok.306b3121.png";